import { Helmet } from "react-helmet-async";
import { Header } from "@/components/Header";
import { ToolsHub } from "@/components/ToolsHub";
import { Footer } from "@/components/Footer";
import { usePageSeo } from "@/hooks/usePageSeo";

const SEOToolsPage = () => {
  const { language, url, onLanguageChange } = usePageSeo();

  const meta = {
    es: {
      title: "Herramientas SEO Gratuitas - Luis ROC | Optimiza tu Contenido",
      description: "Usa nuestras herramientas SEO gratuitas: contador de palabras, generador de meta tags, analizador de URLs, densidad de palabras clave y más. Optimiza tu contenido profesionalmente.",
    },
    en: {
      title: "Free SEO Tools - Luis ROC | Optimize Your Content",
      description: "Use our free SEO tools: word counter, meta tags generator, URL analyzer, keyword density calculator and more. Optimize your content professionally.",
    }
  };

  const currentMeta = meta[language];

  return (
    <>
      <Helmet>
        <html lang={language} />
        <title>{currentMeta.title}</title>
        <meta name="description" content={currentMeta.description} />
        <link rel="canonical" href={url} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={currentMeta.title} />
        <meta property="og:description" content={currentMeta.description} />
        <meta property="og:url" content={url} />
        <meta name="keywords" content="herramientas SEO, contador palabras, meta tags, analizador URL, densidad palabras clave, hash generator, case converter" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header language={language} onLanguageChange={onLanguageChange} />
        
        <main>
          <ToolsHub language={language} />
        </main>
        
        <Footer language={language} />
      </div>
    </>
  );
};

export default SEOToolsPage;